﻿/*
Class: OpaccArticlePrice
Description: Price handling
*/

import { opaccAjaxPlugin, opaccLocalStoragePlugin } from './vendor/script/opacc.static.js';

export class OpaccArticlePrice {
    constructor() {
        this.buttonElementSelector = '.opc-segment-navigation .opc-button[data-op-href]';
        this.selector = '[data-article-async-price]';
        this.articlePriceUrlWrapper = document.getElementById('article-price-url');
        if(this.articlePriceUrlWrapper && this.articlePriceUrlWrapper.hasAttribute('data-op-url') && this.articlePriceUrlWrapper.getAttribute('data-op-url') != '') {
            this.articlePriceUrl = this.articlePriceUrlWrapper.getAttribute('data-op-url');
            this.collectData();
        }
    }

    collectData() {
        this.artNumbers = [];
        const artPriceWrappers = document.querySelectorAll(`${this.selector}[data-op-status="pending"]`);
        artPriceWrappers.forEach(artPriceWrapper => {
            if (artPriceWrapper.hasAttribute('data-op-art-no') && artPriceWrapper.getAttribute('data-op-art-no') != '') {
                this.artNumbers.push(artPriceWrapper.getAttribute('data-op-art-no'));
                artPriceWrapper.setAttribute('data-op-status', 'loading');
            }
        });

        if(this.artNumbers.length > 0) {
            this.loadPrice();
        }
    }

    loadPrice() {
        this.artNumbers.forEach((number) => {
            const data = {
                artNo: number,
            }
            opaccAjaxPlugin.fetchAsynPostForm(this.articlePriceUrl, data, this.showPrice.bind(this), opaccAjaxPlugin.getDefaultErrorFnc, true);
        });
    }

    showPrice(response) {
        const data = response.dataAsJson;
        const priceTargetWrapper = document.querySelector(`${this.selector}[data-op-art-no="${data.artNo}"]`);
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data.html; // Wandelt den String in echtes HTML um
        const decodedHtml = tempDiv.textContent || tempDiv.innerText;
        priceTargetWrapper.innerHTML = decodedHtml;
        priceTargetWrapper.setAttribute('data-op-status', 'done');
    }
}

